'use strict';/* global define:false */// TODO: REDO
define('modules/stats/services/stats-factory',['require'],function(require){'use strict';// @ngInject
model.$inject = ["$resource", "Cancelator", "API_ENDPOINT"];
function model($resource,Cancelator,API_ENDPOINT){var url=API_ENDPOINT+'stats/:type/:id/:action/:param';var params={id:'@id'};var actions={patch:{method:'PATCH'},get:{method:'GET'}};return Cancelator.createResource(url,params,actions);}return model;});
